/* eslint-disable react/no-unescaped-entities */

import { FC } from "react";

import { LegalDocumentVariables } from "../../types";

export const hu: FC<LegalDocumentVariables> = ({
  company,
  site,
  email,
  address,
  country,
  province,
  city,
  postalCode,
  lastUpdated,
  cookiesLink,
}) => {
  return (
    <>
      <div>
        <h1>ADATVÉDELMI SZABÁLYZAT</h1>
        <p>
          <strong>Utolsó frissítés: {lastUpdated}</strong>
        </p>
        <p>
          Ez az adatvédelmi tájékoztató a(z) {company} („<strong>mi</strong>”, „
          <strong>minket</strong>” vagy „<strong>miénk</strong>”) számára
          leírja, hogyan és miért érhetjük el, gyűjthetjük, tárolhatjuk,
          használhatjuk és/vagy oszthatjuk meg („<strong>kezeljük</strong>”)
          személyes adatait, amikor Ön a szolgáltatásainkat („
          <strong>Szolgáltatások</strong>”) használja, ideértve, amikor:
        </p>
        <ul>
          <li>
            Meglátogatja weboldalunkat a <a href={site}>{site}</a> címen vagy
            bármely más weboldalunkat, amely erre az adatvédelmi tájékoztatóra
            hivatkozik
          </li>
          <li>
            Kapcsolatba lép velünk egyéb kapcsolódó módokon, ideértve az
            értékesítést, marketinget vagy eseményeket
          </li>
        </ul>
        <p>
          <strong>Kérdése vagy aggálya van?&nbsp;</strong>Ezen adatvédelmi
          tájékoztató elolvasása segít megérteni az Ön adatvédelmi jogait és
          választási lehetőségeit. Mi vagyunk felelősek azért, hogy döntéseket
          hozzunk személyes adatainak kezeléséről. Ha nem ért egyet
          irányelveinkkel és gyakorlatainkkal, kérjük, ne használja
          szolgáltatásainkat. Ha további kérdése vagy aggálya van, kérjük,
          lépjen kapcsolatba velünk a következő címen: {email}.
        </p>

        <h3>KULCSFONTOSSÁGÚ PONTOK ÖSSZEFOGLALÁSA</h3>
        <p>
          <strong>
            <em>
              Ez az összefoglaló kiemeli az Adatvédelmi tájékoztatónk
              legfontosabb pontjait, de további részleteket találhat bármely
              témáról az egyes pontokhoz tartozó linkre kattintva, vagy
              használhatja az alábbi&nbsp;
            </em>
          </strong>
          <a href="#toc">
            <strong>
              <em>tartalomjegyzéket</em>
            </strong>
          </a>
          <strong>
            <em>, hogy megtalálja a keresett részt.</em>
          </strong>
        </p>
        <p>
          <strong>Milyen személyes adatokat kezelünk?</strong> Amikor
          meglátogatja, használja vagy böngészi szolgáltatásainkat, személyes
          adatokat kezelhetünk attól függően, hogyan lép kapcsolatba velünk és a
          szolgáltatásokkal, milyen döntéseket hoz, illetve milyen termékeket és
          funkciókat használ. Tudjon meg többet az általunk
          <a href="#personalinfo">kezelt személyes adatokról</a>.
        </p>
        <p>
          <strong>Kezelünk érzékeny személyes adatokat?</strong>&nbsp; Bizonyos
          joghatóságokban egyes információkat „különlegesnek” vagy „érzékenynek”
          tekinthetnek, például faji vagy etnikai származás, szexuális
          orientáció vagy vallási meggyőződés. Mi nem kezelünk érzékeny
          személyes adatokat.
        </p>
        <p>
          <strong>Gyűjtünk harmadik felektől származó adatokat?</strong> Nem
          gyűjtünk harmadik felektől származó adatokat.
        </p>
        <p>
          <strong>Hogyan kezeljük adatait?</strong> Az Ön adatait
          szolgáltatásaink nyújtása, fejlesztése és adminisztrálása érdekében,
          valamint kommunikáció, biztonság, csalásmegelőzés és jogszabályi
          megfelelés céljából kezeljük. Adatokat más célokra is kezelhetünk az
          Ön hozzájárulásával. Csak akkor kezeljük az adatait, ha erre érvényes
          jogalapunk van. Tudjon meg többet arról,
          <a href="#infouse">hogyan kezeljük az Ön adatait</a>.
        </p>
        <p>
          <strong>
            Milyen helyzetekben és mely felekkel osztjuk meg személyes adatait?
          </strong>{" "}
          Bizonyos helyzetekben és meghatározott harmadik felekkel megoszthatjuk
          adatait. Tudjon meg többet arról,
          <a href="#whoshare">mikor és kivel osztjuk meg személyes adatait</a>.
        </p>
        <p>
          <strong>Milyen jogai vannak?</strong> Az Ön földrajzi
          elhelyezkedésétől függően az alkalmazandó adatvédelmi jogszabályok
          bizonyos jogokat biztosíthatnak személyes adataival kapcsolatban.
          Tudjon meg többet
          <a href="#privacyrights">adatvédelmi jogairól</a>.
        </p>
        <p>
          <strong>Hogyan gyakorolhatja jogait?</strong> Jogainak legegyszerűbb
          módja, ha ellátogat a <a href={site}>{site}</a> weboldalra, vagy
          kapcsolatba lép velünk. Minden kérelmet megvizsgálunk és kezelünk az
          alkalmazandó adatvédelmi jogszabályok szerint.
        </p>
        <p>
          Szeretne többet megtudni arról, mit teszünk az összegyűjtött
          adatokkal?{" "}
          <a href="#toc">Olvassa el a teljes adatvédelmi tájékoztatót</a>.
        </p>
        <div id="toc">
          <h2>TARTALOMJEGYZÉK</h2>
          <ol>
            <li>
              <a href="#infocollect">MILYEN ADATOKAT GYŰJTÜNK?</a>
            </li>
            <li>
              <a href="#infouse">HOGYAN KEZELJÜK AZ ÖN ADATAIT?</a>
            </li>
            <li>
              <a href="#legalbases">
                MILYEN JOGALAPOKRA HIVATKOZVA KEZELJÜK AZ ÖN SZEMÉLYES ADATAIT?
              </a>
            </li>
            <li>
              <a href="#whoshare">
                MIKOR ÉS KIVEL OSZTJUK MEG AZ ÖN SZEMÉLYES ADATAIT?
              </a>
            </li>
            <li>
              <a href="#cookies">
                HASZNÁLUNK COOKIE-KAT ÉS MÁS NYOMKÖVETŐ TECHNOLÓGIÁKAT?
              </a>
            </li>
            <li>
              <a href="#ai">
                KÍNÁLUNK MESTERSÉGES INTELLIGENCIÁN ALAPULÓ TERMÉKEKET?
              </a>
            </li>
            <li>
              <a href="#sociallogins">
                HOGYAN KEZELJÜK A KÖZÖSSÉGI BEJELENTKEZÉSEIT?
              </a>
            </li>
            <li>
              <a href="#inforetain">MEDDIG TÁROLJUK AZ ÖN ADATAIT?</a>
            </li>
            <li>
              <a href="#infominors">GYŰJTÜNK ADATOKAT KISKORÚAKTÓL?</a>
            </li>
            <li>
              <a href="#privacyrights">MIK AZ ÖN ADATVÉDELMI JOGAI?</a>
            </li>
            <li>
              <a href="#DNT">DO-NOT-TRACK FUNKCIÓK KEZELÉSE</a>
            </li>
            <li>
              <a href="#policyupdates">FRISSÍTJÜK EZT A TÁJÉKOZTATÓT?</a>
            </li>
            <li>
              <a href="#contact">HOGYAN LÉPHET VELÜNK KAPCSOLATBA?</a>
            </li>
            <li>
              <a href="#request">
                HOGYAN TEKINTHETI MEG, FRISSÍTHETI VAGY TÖRÖLHETI AZ ÁLTALUNK
                GYŰJTÖTT ADATOKAT?
              </a>
            </li>
          </ol>
        </div>
      </div>
      <div id="infocollect">
        <h2>1. MILYEN ADATOKAT GYŰJTÜNK?</h2>
        <p>
          <strong>Az Ön által megadott személyes adatok</strong>
        </p>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>Az Ön által megadott személyes adatokat gyűjtjük.</em>
        </p>
        <p>
          Azokat a személyes adatokat gyűjtjük, amelyeket önként ad meg nekünk,
          amikor regisztrál a szolgáltatásainkra, érdeklődést mutat irántunk
          vagy termékeink és szolgáltatásaink iránt, amikor részt vesz a
          szolgáltatásokhoz kapcsolódó tevékenységekben, vagy amikor más módon
          kapcsolatba lép velünk.
        </p>
        <p>
          <strong>Ön által megadott személyes adatok.</strong> Az általunk
          gyűjtött személyes adatok függnek az Ön velünk és a szolgáltatásokkal
          való interakciójától, az Ön döntéseitől, valamint az Ön által használt
          termékektől és funkcióktól. A gyűjtött személyes adatok többek között
          a következők lehetnek:
        </p>
        <ul>
          <li>nevek</li>
        </ul>
        <ul>
          <li>telefonszámok</li>
        </ul>
        <ul>
          <li>e-mail címek</li>
        </ul>
        <ul>
          <li>felhasználónevek</li>
        </ul>
        <ul>
          <li>jelszavak</li>
        </ul>
        <ul>
          <li>kapcsolattartási preferenciák</li>
        </ul>
        <ul>
          <li>kapcsolattartási vagy hitelesítési adatok</li>
        </ul>
        <ul>
          <li>bank- vagy hitelkártyaszámok</li>
        </ul>
        <ul>
          <li>számlázási címek</li>
        </ul>
        <p>
          <strong>Érzékeny adatok.</strong> Nem kezelünk érzékeny adatokat.
        </p>
        <p>
          <strong>Fizetési adatok.</strong> Fizetési adatait (például bankkártya
          számát és biztonsági kódját) akkor gyűjthetjük, ha vásárlást végez
          szolgáltatásaink használata során. Minden fizetési adatot a Stripe
          kezel és tárol. Az ő adatvédelmi tájékoztatójukat itt találja:{" "}
          <a href="https://stripe.com/privacy">https://stripe.com/privacy</a>.
        </p>
        <p>
          <strong>Közösségi média bejelentkezési adatok.</strong> Lehetőséget
          kínálhatunk arra, hogy meglévő közösségi média fiókjával, például
          Facebook, X vagy más fiókjával regisztráljon nálunk. Ha ezt választja,
          bizonyos profiladatokat gyűjtünk Önről a közösségi média
          szolgáltatótól, az alábbi '
          <a href="#sociallogins">
            HOGYAN KEZELJÜK A KÖZÖSSÉGI BEJELENTKEZÉSEIT?
          </a>
          ' szakaszban leírtak szerint.
        </p>
        <p>
          Az Ön által megadott minden személyes adatnak igaznak, teljesnek és
          pontosnak kell lennie, és köteles értesíteni minket minden ilyen
          adatban bekövetkező változásról.
        </p>
        <h3>Automatikusan gyűjtött információk</h3>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>
            Bizonyos információkat – például az Ön IP-címét és/vagy böngésző- és
            eszközjellemzőit – automatikusan gyűjtjük, amikor meglátogatja
            szolgáltatásainkat.
          </em>
        </p>
        <p>
          Automatikusan gyűjtünk bizonyos adatokat, amikor meglátogatja,
          használja vagy böngészi a szolgáltatásokat. Ezek az információk nem
          fedik fel az Ön konkrét személyazonosságát (például nevét vagy
          elérhetőségeit), de tartalmazhatnak eszköz- és használati
          információkat, például IP-címet, böngésző- és eszközjellemzőket,
          operációs rendszert, nyelvi preferenciákat, hivatkozó URL-eket, eszköz
          nevét, országot, helyszínt, valamint információkat arról, hogy hogyan
          és mikor használja a szolgáltatásokat, valamint egyéb technikai
          adatokat. Ezek az információk elsősorban a szolgáltatásaink
          biztonságának és működésének fenntartásához, illetve belső elemzési és
          jelentési céljainkra szükségesek.
        </p>
        <p>
          Sok más vállalkozáshoz hasonlóan mi is gyűjtünk adatokat sütik és
          hasonló technológiák révén. További részleteket Cookie
          Tájékoztatónkban találhat: <a href={cookiesLink}>{cookiesLink}</a>.
        </p>
        <p>Az általunk gyűjtött információk a következők:</p>
        <ul>
          <li>
            <em>Naplózási és használati adatok.</em> Szolgáltatásaink
            használatával kapcsolatos diagnosztikai, használati és
            teljesítményadatok, amelyeket szervereink automatikusan gyűjtenek és
            naplófájlokban tárolnak.
          </li>
          <li>
            <em>Eszközadatok.</em> Az Ön által használt számítógép, telefon,
            tablet vagy más eszköz adatai.
          </li>
          <li>
            <em>Helyadatok.</em> Az Ön készülékének helyadatai, amelyek lehetnek
            pontosak vagy pontatlanok.
          </li>
        </ul>
        <p>
          <strong>Google API</strong>
        </p>
        <p>
          A Google API-któl kapott információk felhasználása megfelel a{" "}
          <a href="https://developers.google.com/terms/api-services-user-data-policy">
            Google API Services User Data Policy
          </a>
          -nek, beleértve a{" "}
          <a href="https://developers.google.com/terms/api-services-user-data-policy#limited-use">
            korlátozott felhasználási követelményeket
          </a>{" "}
          is.
        </p>
      </div>
      <div id="infouse">
        <h2>2. HOGYAN KEZELJÜK AZ ÖN ADATAIT?</h2>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>
            Az Ön adatait a szolgáltatásaink nyújtása, fejlesztése, kezelése,
            kommunikáció, biztonság és csalásmegelőzés céljából, valamint a
            jogszabályok betartása érdekében kezeljük. Az Ön hozzájárulásával
            további célokra is kezelhetjük adatait.
          </em>
        </p>
        <p>
          <strong>
            Az Ön személyes adatait többféle okból kezelhetjük, attól függően,
            hogyan használja szolgáltatásainkat, ideértve:
          </strong>
        </p>
        <ul>
          <li>
            <strong>
              Fióklétrehozás és hitelesítés, valamint a felhasználói fiókok
              kezelése.
            </strong>{" "}
            Kezelhetjük az Ön adatait, hogy fiókot hozzon létre, bejelentkezzen,
            és működőképes állapotban tartsa fiókját.
          </li>
          <li>
            <strong>Visszajelzés kérése.</strong> Kezelhetjük adatait, hogy
            visszajelzést kérjünk, és felvegyük Önnel a kapcsolatot a
            szolgáltatásaink használatával kapcsolatban.
          </li>
          <li>
            <strong>Marketing- és promóciós kommunikáció küldése.</strong> Az Ön
            által megadott személyes adatokat marketing célokra használhatjuk,
            amennyiben ez megfelel az Ön marketingpreferenciáinak. Bármikor
            leiratkozhat marketing e-mailjeinkről. További információért lásd az
            alábbi '<a href="#privacyrights">MIK AZ ÖN ADATVÉDELMI JOGAI?</a>'
            részt.
          </li>
          <li>
            <strong>Célzott hirdetések megjelenítése.</strong> Kezelhetjük
            adatait, hogy személyre szabott tartalmakat és hirdetéseket
            jelenítsünk meg Önnek érdeklődési körének és helyzetének
            megfelelően. További részleteket talál Cookie Tájékoztatónkban:{" "}
            <a href={cookiesLink}>{cookiesLink}</a>.
          </li>
          <li>
            <strong>Szolgáltatásaink védelme.</strong> Az Ön adatait a
            szolgáltatásaink biztonságának és védelmének részeként kezelhetjük,
            ideértve a csalás figyelését és megelőzését.
          </li>
          <li>
            <strong>Használati trendek elemzése.</strong> Kezelhetjük adatait,
            hogy jobban megértsük, hogyan használják a szolgáltatásokat, így
            javíthatjuk azokat.
          </li>
          <li>
            <strong>
              Marketing- és promóciós kampányaink hatékonyságának felmérése.
            </strong>{" "}
            Az Ön adatait azért kezelhetjük, hogy jobban megértsük, hogyan
            nyújthatunk Önnek releváns marketing- és promóciós kampányokat.
          </li>
          <li>
            <strong>Egyének létfontosságú érdekeinek védelme.</strong>{" "}
            Kezelhetjük adatait, ha szükséges az egyének létfontosságú
            érdekeinek védelméhez, például veszélyhelyzetek megelőzésére.
          </li>
        </ul>
      </div>
      <div id="legalbases">
        <h2>
          3. MILYEN JOGALAPOKRA HIVATKOZVA KEZELJÜK AZ ÖN SZEMÉLYES ADATAIT?
        </h2>
        <p>
          <em>
            <strong>Röviden:&nbsp;</strong>
            Az Ön személyes adatait kizárólag akkor kezeljük, amikor úgy véljük,
            hogy szükséges, és erre érvényes jogalapunk van az alkalmazandó
            jogszabályok szerint, például az Ön hozzájárulásával, jogi
            kötelezettségek betartásához, szerződéses kötelezettségeink
            teljesítéséhez, az Ön jogainak védelméhez vagy jogos üzleti
            érdekeink érvényesítéséhez.
          </em>
        </p>
        <p>
          Az általános adatvédelmi rendelet (GDPR) és a brit GDPR előírja, hogy
          ismertessük azokat a jogalapokat, amelyekre támaszkodva kezeljük
          személyes adatait. Az alábbi jogalapokra támaszkodhatunk személyes
          adatainak kezeléséhez:
        </p>
        <ul>
          <li>
            <strong>Hozzájárulás.</strong> Kezelhetjük adatait, ha engedélyt
            adott személyes adatai konkrét célra történő felhasználásához.
            Hozzájárulását bármikor visszavonhatja. További információért lásd{" "}
            <a href="#withdrawconsent">hozzájárulás visszavonása</a>.
          </li>
          <li>
            <strong>Jogos érdekek.</strong> Kezelhetjük adatait, ha úgy véljük,
            ez ésszerűen szükséges jogos üzleti érdekeink érvényesítéséhez, és
            ezek az érdekek nem írják felül az Ön érdekeit, alapvető jogait és
            szabadságait. Például kezelhetjük személyes adatait a következő
            célokra:
            <ul>
              <li>
                Különleges ajánlatok és kedvezmények küldése termékeinkre és
                szolgáltatásainkra
              </li>
              <li>
                Személyre szabott reklámtartalom fejlesztése és megjelenítése
              </li>
              <li>
                Szolgáltatásaink használatának elemzése a felhasználói élmény
                javítása érdekében
              </li>
              <li>Marketingtevékenységünk támogatása</li>
              <li>Problémák diagnosztizálása és csalás megelőzése</li>
              <li>
                Felhasználói viselkedés megértése termékeink és szolgáltatásaink
                javításához
              </li>
            </ul>
          </li>
          <li>
            <strong>Jogi kötelezettségek.</strong> Kezelhetjük adatait jogi
            kötelezettségeink teljesítéséhez, például bűnüldöző szervekkel vagy
            hatóságokkal való együttműködéshez.
          </li>
          <li>
            <strong>Létfontosságú érdekek.</strong> Kezelhetjük adatait az Ön
            vagy mások létfontosságú érdekeinek védelméhez, például
            életveszélyes helyzetek esetén.
          </li>
        </ul>
      </div>
      <div id="whoshare">
        <h2>4. MIKOR ÉS KIVEL OSZTJUK MEG AZ ÖN SZEMÉLYES ADATAIT?</h2>
        <p>
          <strong>
            <em>Röviden:</em>
          </strong>
          <em>
            Bizonyos helyzetekben és az alább felsorolt harmadik felekkel
            oszthatjuk meg az Ön adatait.
          </em>
        </p>
        <p>
          <strong>
            Beszállítók, tanácsadók és egyéb harmadik fél szolgáltatók.
          </strong>{" "}
          Az Ön adatait megoszthatjuk harmadik fél beszállítókkal,
          szolgáltatókkal, alvállalkozókkal vagy ügynökökkel („
          <strong>harmadik felek</strong>”), akik szolgáltatásokat nyújtanak
          számunkra vagy a nevünkben dolgoznak, és akiknek szüksége van az
          adatokhoz való hozzáférésre a feladataik elvégzéséhez.
        </p>
        <p>A személyes adatokat megoszthatjuk a következő harmadik felekkel:</p>
        <ul>
          <li>
            <strong>AI szolgáltatók</strong>
          </li>
        </ul>
        <p>OpenAI</p>
        <ul>
          <li>
            <strong>
              Harmadik fél fiókokhoz történő kapcsolódás engedélyezése
            </strong>
          </li>
        </ul>
        <p>Facebook fiók, Google fiók és Apple fiók</p>
        <ul>
          <li>
            <strong>Felhőalapú szolgáltatások</strong>
          </li>
        </ul>
        <p>Amazon Web Services (AWS)</p>
        <ul>
          <li>
            <strong>Felhasználókkal való kommunikáció és csevegés</strong>
          </li>
        </ul>
        <p>WhatsApp, Telegram, Instagram és Facebook Customer Chat</p>
        <ul>
          <li>
            <strong>Tartalomoptimalizálás</strong>
          </li>
        </ul>
        <p>Google Site Search</p>
        <ul>
          <li>
            <strong>Adatmentés és biztonság</strong>
          </li>
        </ul>
        <p>Amazon Glacier</p>
        <ul>
          <li>
            <strong>Funkcionalitás és infrastruktúra optimalizálása</strong>
          </li>
        </ul>
        <p>Amazon Web Services</p>
        <ul>
          <li>
            <strong>Számlázás és fizetés</strong>
          </li>
        </ul>
        <p>Stripe</p>
        <ul>
          <li>
            <strong>Újracélzási platformok</strong>
          </li>
        </ul>
        <p>
          Google Ads Remarketing, Facebook Remarketing és Facebook Custom
          Audience
        </p>
        <ul>
          <li>
            <strong>Közösségi média megosztás és hirdetés</strong>
          </li>
        </ul>
        <p>Facebook hirdetések és Reddit bővítmények</p>
        <ul>
          <li>
            <strong>Felhasználói fiók regisztráció és hitelesítés</strong>
          </li>
        </ul>
        <p>
          Facebook bejelentkezés, Google bejelentkezés és Apple bejelentkezés
        </p>
        <ul>
          <li>
            <strong>Felhasználói hozzászólások és fórumok</strong>
          </li>
        </ul>
        <p>Telegram és Facebook hozzászólások</p>
        <ul>
          <li>
            <strong>Webes és mobil analitika</strong>
          </li>
        </ul>
        <p>Google Analytics és Hotjar</p>
        <ul>
          <li>
            <strong>Weboldal tárhely</strong>
          </li>
        </ul>
        <p>Amazon Amplify</p>
        <ul>
          <li>
            <strong>Weboldal teljesítményfigyelés</strong>
          </li>
        </ul>
        <p>Sentry</p>
        <p>
          Az alábbi helyzetekben is szükségessé válhat személyes adatainak
          megosztása:
        </p>
        <ul>
          <li>
            <strong>Üzleti tranzakciók.</strong> Megoszthatjuk vagy átadhatjuk
            az Ön adatait bármilyen fúzió, vállalati eszközök értékesítése,
            finanszírozás, vagy vállalkozásunk egészének vagy egy részének más
            vállalatra való átruházása során vagy annak tárgyalási szakaszában.
          </li>
        </ul>
      </div>
      <div id="cookies">
        <h2>5. HASZNÁLUNK COOKIE-KAT ÉS MÁS NYOMKÖVETŐ TECHNOLÓGIÁKAT?</h2>
        <p>
          <strong>
            <em>Röviden:</em>
          </strong>
          <em>
            Cookie-kat és más nyomkövető technológiákat használhatunk az Ön
            adatainak gyűjtésére és tárolására.
          </em>
        </p>
        <p>
          Cookie-kat és hasonló nyomkövető technológiákat (például web
          beacon-öket és pixeleket) használhatunk, amikor Ön kapcsolatba lép
          szolgáltatásainkkal. Egyes nyomkövető technológiák segítenek a
          szolgáltatásaink és az Ön fiókjának biztonságban tartásában, hibák
          megelőzésében, hibák javításában, az Ön preferenciáinak mentésében,
          valamint alapvető oldal funkciók biztosításában.
        </p>
        <p>
          Harmadik feleknek és szolgáltatóknak is engedélyezzük, hogy online
          nyomkövető technológiákat használjanak szolgáltatásainkon analitikai
          és hirdetési célokra, ideértve a hirdetések kezelését és személyre
          szabását, valamint például elhagyott kosár emlékeztetők küldését (az
          Ön kommunikációs preferenciáitól függően). Harmadik felek és
          szolgáltatók technológiáikat arra használják, hogy az Ön érdeklődési
          körére szabott hirdetéseket jelenítsenek meg, amelyek megjelenhetnek
          szolgáltatásainkon vagy más webhelyeken.
        </p>
        <p>
          Részletes információkat arról, hogy hogyan használjuk ezeket a
          technológiákat, és hogyan utasíthat vissza bizonyos cookie-kat, a
          Cookie Tájékoztatónk tartalmazza:{" "}
          <a href={cookiesLink}>{cookiesLink}</a>.
        </p>
        <h3>Google Analytics</h3>
        <p>
          Megoszthatjuk adatait a Google Analytics szolgáltatással a
          szolgáltatások használatának nyomon követése és elemzése érdekében. A
          Google Analytics hirdetési funkciók, amelyeket használhatunk, a
          következők: Remarketing a Google Analytics segítségével, Google
          Display Network Impressions Reporting és Google Analytics Demographics
          and Interests Reporting. A Google Analytics általi követés
          kikapcsolásához látogasson el ide:{" "}
          <a href="https://tools.google.com/dlpage/gaoptout">
            https://tools.google.com/dlpage/gaoptout
          </a>
          . A Google Analytics hirdetési funkciókat kikapcsolhatja az{" "}
          <a href="https://adssettings.google.com/">Ads Settings</a> oldalán és
          a mobilalkalmazás Ads Settings-ben. További kikapcsolási lehetőségek:{" "}
          <a href="http://optout.networkadvertising.org/">
            http://optout.networkadvertising.org/
          </a>{" "}
          és{" "}
          <a href="http://www.networkadvertising.org/mobile-choice">
            http://www.networkadvertising.org/mobile-choice
          </a>
          . A Google adatvédelmi gyakorlatáról további információt a{" "}
          <a href="https://policies.google.com/privacy">
            Google Adatvédelem és Feltételek
          </a>{" "}
          oldalon talál.
        </p>
      </div>
      <div id="ai">
        <h2>6. KÍNÁLUNK MESTERSÉGES INTELLIGENCIÁN ALAPULÓ TERMÉKEKET?</h2>
        <p>
          <strong>
            <em>Röviden:</em>
          </strong>
          <em>
            Kínálunk mesterséges intelligencia, gépi tanulás vagy hasonló
            technológiák által működtetett termékeket, funkciókat vagy
            eszközöket.
          </em>
        </p>
        <p>
          Szolgáltatásaink részeként kínálunk mesterséges intelligencia, gépi
          tanulás vagy hasonló technológiák által működtetett termékeket,
          funkciókat vagy eszközöket (együttesen „AI termékek”). Ezek az
          eszközök az Ön élményének fokozására és innovatív megoldások
          biztosítására szolgálnak. Jelen Adatvédelmi tájékoztató feltételei
          szabályozzák az AI termékek használatát a szolgáltatásainkban.
        </p>
        <h3>AI technológiák használata</h3>
        <p>
          Az AI termékeket harmadik fél szolgáltatókon („AI szolgáltatók”)
          keresztül biztosítjuk, többek között az OpenAI-n keresztül. Ahogy azt
          jelen Adatvédelmi tájékoztató részletezi, az Ön által megadott
          információk, a létrehozott tartalmak és személyes adatok megosztásra
          kerülhetnek, illetve feldolgozásra kerülnek ezekkel az AI
          szolgáltatókkal, hogy lehetővé tegyük Önnek AI termékeink használatát
          az alábbiakban részletezett célokra: „
          <a href="#legalbases">
            MILYEN JOGALAPOKRA HIVATKOZVA KEZELJÜK AZ ÖN SZEMÉLYES ADATAIT?
          </a>
          ” Ön nem használhatja az AI termékeket az AI szolgáltatók feltételeit
          vagy irányelveit megsértve.
        </p>
        <h3>AI termékeink</h3>
        <p>AI termékeinket a következő célokra terveztük:</p>
        <ul>
          <li>AI automatizáció</li>
          <li>AI alkalmazások</li>
          <li>AI fejlesztés</li>
          <li>Szövegelemzés</li>
          <li>AI prediktív elemzés</li>
          <li>AI kutatás</li>
          <li>Természetes nyelvfeldolgozás (NLP)</li>
          <li>Gépi tanulási modellek</li>
        </ul>
        <h3>Hogyan kezeljük adatait AI segítségével?</h3>
        <p>
          Minden személyes adat, amelyet AI termékeinkkel dolgozunk fel, az
          Adatvédelmi tájékoztatónkkal és harmadik felekkel kötött
          megállapodásainkkal összhangban történik. Ez biztosítja az adatok
          magas fokú biztonságát és személyes adatainak védelmét az egész
          folyamat során, így nyugodt lehet adatai biztonságát illetően.
        </p>
      </div>
      <div id="sociallogins">
        <h2>7. HOGYAN KEZELJÜK A KÖZÖSSÉGI MÉDIA BEJELENTKEZÉSEIT?</h2>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>
            Ha úgy dönt, hogy közösségi média fiókjával regisztrál vagy
            jelentkezik be szolgáltatásainkba, hozzáférhetünk bizonyos
            adataihoz.
          </em>
        </p>
        <p>
          Szolgáltatásaink lehetőséget nyújtanak harmadik fél közösségi média
          fiókjával (például Facebook vagy X fiókjával) történő regisztrációra
          és bejelentkezésre. Ha ezt a lehetőséget választja, bizonyos
          profiladatokat kapunk az adott közösségi média szolgáltatótól. A
          kapott profiladatok szolgáltatónként eltérőek lehetnek, de általában
          tartalmazzák az Ön nevét, e-mail címét, ismerősei listáját,
          profilképét, valamint azokat az információkat, amelyeket nyilvánossá
          tett az adott közösségi platformon.
        </p>
        <p>
          A kapott információkat kizárólag az ebben az Adatvédelmi
          tájékoztatóban ismertetett célokra vagy az adott szolgáltatásban
          egyértelműen jelzett célokra használjuk fel. Felhívjuk figyelmét, hogy
          nem ellenőrizzük, és nem vállalunk felelősséget azért, hogyan
          használja fel személyes adatait a harmadik fél közösségi média
          szolgáltatója. Javasoljuk, hogy tekintse át az adott szolgáltató
          adatvédelmi tájékoztatóját, hogy megértse, hogyan gyűjtik, használják
          fel, és osztják meg személyes adatait, és hogyan állíthatja be
          adatvédelmi preferenciáit az oldalukon és alkalmazásaikban.
        </p>
      </div>
      <div id="inforetain">
        <h2>8. MENNYI IDEIG ŐRIZZÜK MEG AZ ÖN ADATAIT?</h2>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>
            Adatait addig őrizzük meg, amíg az Adatvédelmi tájékoztatóban leírt
            célok megvalósításához szükséges, kivéve, ha jogszabály másként
            rendelkezik.
          </em>
        </p>
        <p>
          Személyes adatait csak annyi ideig tároljuk, amennyi az Adatvédelmi
          tájékoztatóban leírt célok eléréséhez szükséges, kivéve, ha hosszabb
          tárolási időt ír elő vagy enged meg a jog (például adózási, számviteli
          vagy más jogi követelmények miatt). Ebben a tájékoztatóban semmilyen
          cél nem követeli meg, hogy adatait tovább őrizzük, mint ameddig fiókja
          nálunk aktív.
        </p>
        <p>
          Amikor már nincs jogos üzleti érdekünk személyes adatai kezelésére,
          vagy töröljük, vagy anonimizáljuk ezeket az adatokat, ha pedig ez nem
          lehetséges (például ha az adatok biztonsági mentésekben tárolódnak),
          akkor biztonságosan tároljuk és elkülönítjük minden további
          kezeléstől, amíg törlésük lehetséges nem lesz.
        </p>
      </div>
      <div id="infominors">
        <h2>9. GYŰJTÜNK ADATOKAT KISKORÚAKTÓL?</h2>
        <p>
          <strong>
            <em>Röviden:</em>
          </strong>
          <em>
            Nem gyűjtünk szándékosan adatokat 18 éven aluli gyermekektől, és nem
            is hirdetünk nekik.
          </em>
        </p>
        <p>
          Nem gyűjtünk szándékosan adatokat 18 éven aluli gyermekektől, nem is
          kérünk be tőlük adatokat, és nem értékesítjük személyes adataikat. A
          szolgáltatások használatával Ön kijelenti, hogy legalább 18 éves, vagy
          kiskorú esetében szülő vagy törvényes gyám, aki beleegyezik abba, hogy
          a kiskorú használja a szolgáltatásokat. Ha tudomásunkra jut, hogy 18
          éven aluli felhasználótól gyűjtöttünk személyes adatokat, deaktiváljuk
          a fiókot, és ésszerű intézkedéseket teszünk az ilyen adatok
          haladéktalan törlésére nyilvántartásunkból. Ha tudomása van arról,
          hogy esetleg adatokat gyűjtöttünk 18 éven aluli gyermekektől, kérjük,
          vegye fel velünk a kapcsolatot az alábbi címen: {email}.
        </p>
      </div>
      <div id="privacyrights">
        <h2>10. MIK AZ ÖN ADATVÉDELMI JOGAI?</h2>
        <p>
          <strong>
            <em>Röviden:&nbsp;</em>
          </strong>
          <em>
            Egyes régiókban, mint például az Európai Gazdasági Térségben (EGT),
            az Egyesült Királyságban (UK) és Svájcban, Önnek olyan jogai vannak,
            amelyek lehetővé teszik, hogy nagyobb hozzáférése és ellenőrzése
            legyen személyes adatai felett. Országától, tartományától vagy
            államától függően bármikor ellenőrizheti, módosíthatja vagy
            megszüntetheti fiókját.
          </em>
        </p>
        <p>
          Egyes régiókban (például az EGT, UK és Svájc) az alkalmazandó
          adatvédelmi törvények bizonyos jogokat biztosítanak Önnek. Ezek közé
          tartozhat a jog (i) a személyes adataihoz való hozzáférés és másolat
          kérésére, (ii) helyesbítés vagy törlés kérésére, (iii) személyes
          adatai kezelésének korlátozására, (iv) adott esetben
          adathordozhatóságra és (v) hogy ne vonatkozzon Önre automatizált
          döntéshozatal. Bizonyos körülmények között joga van tiltakozni
          személyes adatainak kezelése ellen is. Ilyen kérelmet a '
          <a href="#contact">HOGYAN LÉPHET VELÜNK KAPCSOLATBA?</a>' szakaszban
          található elérhetőségeinken keresztül nyújthat be.
        </p>
        <p>
          A kérelmeket az alkalmazandó adatvédelmi törvények szerint vizsgáljuk
          meg és kezeljük.
        </p>
        <p>
          Ha Ön az EGT-ben vagy az Egyesült Királyságban tartózkodik, és úgy
          véli, hogy jogellenesen kezeljük személyes adatait, joga van panaszt
          tenni az illetékes{" "}
          <a href="https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">
            tagállami adatvédelmi hatóságnál
          </a>{" "}
          vagy az{" "}
          <a href="https://ico.org.uk/make-a-complaint/data-protection-complaints/data-protection-complaints/">
            Egyesült Királyság adatvédelmi hatóságánál
          </a>
          .
        </p>
        <p>
          Ha Svájcban tartózkodik, kapcsolatba léphet a{" "}
          <a href="https://www.edoeb.admin.ch/edoeb/en/home.html">
            Szövetségi Adatvédelmi és Információs Biztossal
          </a>
          .
        </p>
        <p>
          <strong>
            <u>Hozzájárulás visszavonása:</u>
          </strong>{" "}
          Ha hozzájárulása alapján kezeljük személyes adatait, Ön jogosult ezt a
          hozzájárulást bármikor visszavonni. Hozzájárulását a '
          <a href="#contact">HOGYAN LÉPHET VELÜNK KAPCSOLATBA?</a>' szakaszban
          található elérhetőségeinken vagy preferenciáinak frissítésével
          vonhatja vissza.
        </p>
        <p>
          Vegye figyelembe, hogy ez nem érinti a visszavonás előtti adatkezelés
          jogszerűségét, és nem érinti azokat az adatkezeléseket sem, amelyek
          más jogalapon alapulnak, nem pedig a hozzájáruláson.
        </p>
        <p>
          <strong>
            <u>Marketing és promóciós kommunikáció letiltása:</u>
          </strong>{" "}
          Marketing és promóciós kommunikációról bármikor leiratkozhat, az
          e-mailjeinkben található leiratkozási linkre kattintva, vagy a '
          <a href="#contact">HOGYAN LÉPHET VELÜNK KAPCSOLATBA?</a>' szakaszban
          megadott elérhetőségeken keresztül. Ezután eltávolítjuk a marketing
          listákról. Továbbra is küldhetünk Önnek például szolgáltatással
          kapcsolatos üzeneteket, amelyek szükségesek fiókja kezeléséhez,
          szolgáltatási igényekre való válaszadáshoz, vagy más, nem marketing
          jellegű célokra.
        </p>
        <h3>Fiókinformációk</h3>
        <p>
          Ha bármikor szeretné áttekinteni vagy módosítani fiókja adatait, vagy
          megszüntetni fiókját, ezt megteheti az alábbi módon:
        </p>
        <ul>
          <li>
            Jelentkezzen be fiókja beállításaiba, és frissítse felhaszálói
            adatait.
          </li>
        </ul>
        <p>
          Fiókjának megszüntetésére vonatkozó kérelme után deaktiváljuk vagy
          töröljük fiókját és adatait aktív adatbázisunkból. Bizonyos adatokat
          azonban megtarthatunk fájljainkban a csalások megelőzése, problémák
          elhárítása, vizsgálatok támogatása, jogi feltételeink betartatása és
          jogszabályi kötelezettségek betartása érdekében.
        </p>
        <p>
          <strong>
            <u>Cookie-k és hasonló technológiák:</u>
          </strong>{" "}
          A legtöbb böngésző alapértelmezetten elfogadja a cookie-kat.
          Amennyiben szeretné, általában beállíthatja böngészőjét úgy, hogy
          törölje vagy elutasítsa a cookie-kat. Ha úgy dönt, hogy törli vagy
          elutasítja a cookie-kat, ez érintheti a szolgáltatásaink bizonyos
          funkcióit vagy szolgáltatásait. További információkat a Cookie
          Tájékoztatónkban találhat: <a href={cookiesLink}>{cookiesLink}</a>.
        </p>
        <p>
          Ha kérdése vagy észrevétele van adatvédelmi jogaival kapcsolatban,
          írjon nekünk a következő e-mail címre: {email}.
        </p>
      </div>
      <div id="DNT">
        <h2>11. „DO-NOT-TRACK” FUNKCIÓK KEZELÉSE</h2>
        <p>
          A legtöbb webböngésző, valamint néhány mobil operációs rendszer és
          alkalmazás tartalmazza a „Do-Not-Track” („DNT”) funkciót, amelynek
          bekapcsolásával jelezheti, hogy nem szeretné, ha online böngészési
          tevékenységét nyomon követnék és gyűjtenék. Jelenleg nincs egységes
          technológiai szabvány a DNT jelek felismerésére és kezelésére. Emiatt
          jelenleg nem válaszolunk a DNT böngészőjelekre vagy egyéb automatikus
          mechanizmusokra, amelyek közlik velünk az Ön választását arról, hogy
          nem szeretné, ha online követnék. Ha a jövőben elfogadnak egy online
          követési szabványt, amelyet kötelesek vagyunk követni, erről
          tájékoztatni fogjuk Önt ezen Adatvédelmi tájékoztató frissített
          változatában.
        </p>
      </div>
      <div id="policyupdates">
        <h2>12. FRISSÍTJÜK EZT A TÁJÉKOZTATÓT?</h2>
        <p>
          <em>
            <strong>Röviden:&nbsp;</strong>
            Igen, szükség szerint frissítjük ezt a tájékoztatót, hogy
            megfeleljünk az alkalmazandó jogszabályoknak.
          </em>
        </p>
        <p>
          Ezt az Adatvédelmi tájékoztatót időről időre frissíthetjük. A
          frissített verzió dátuma a tájékoztató elején „Utolsó frissítés”
          címmel lesz feltüntetve. Ha jelentős változtatásokat végzünk, erről
          kiemelt értesítést helyezhetünk el, vagy közvetlenül értesíthetjük
          Önt. Javasoljuk, hogy rendszeresen tekintse át ezt a tájékoztatót,
          hogy tájékozott maradjon arról, hogyan védjük az Ön adatait.
        </p>
      </div>
      <div id="contact">
        <h2>13. HOGYAN LÉPHET VELÜNK KAPCSOLATBA?</h2>
        <div>
          Ha kérdése vagy észrevétele van ezzel a tájékoztatóval kapcsolatban,
          írjon nekünk az alábbi e-mail címre: {email}, vagy vegye fel velünk a
          kapcsolatot postai úton:
        </div>
        <p>
          <strong>{company}</strong>
        </p>
        <p>
          {country}, {province} {postalCode}, {city}, {address}
        </p>
      </div>
      <div id="request">
        <h2>
          14. HOGYAN TEKINTHETI MEG, FRISSÍTHETI VAGY TÖRÖLHETI AZ ÁLTALUNK
          GYŰJTÖTT ADATOKAT?
        </h2>
        <p>
          Az országában alkalmazandó jogszabályoktól függően Ön jogosult lehet
          arra, hogy hozzáférjen az általunk gyűjtött személyes adataihoz,
          információt kapjon azok kezeléséről, helyesbítse a pontatlanságokat
          vagy törölje személyes adatait. Jogában állhat továbbá visszavonni a
          személyes adatainak kezelésére adott hozzájárulását is. Ezeket a
          jogokat bizonyos körülmények között korlátozhatják az alkalmazandó
          törvények. Ha át kívánja tekinteni, frissíteni vagy törölni személyes
          adatait, kérjük, látogasson el a következő oldalra:{" "}
          <a href={site}>{site}</a>.
        </p>
      </div>
    </>
  );
};
